import Vue from 'vue'
import VueRouter from 'vue-router'
import {reportApiError} from "./utils";

window.Vue = Vue
Vue.use(VueRouter)

// Sentry logging & error handling.
require('./sentry')

// Keen UI
import KeenUI from 'keen-ui/src/index';
Vue.use(KeenUI);

// Vue Observe Visibility
import VueObserveVisibility from 'vue-observe-visibility'
Vue.use(VueObserveVisibility)

// Smooth-scroll polyfill
require('smoothscroll-polyfill').polyfill();

window.addClass = (ele, classname) => {
    if (ele && ele.className && -1 === ele.className.indexOf(classname)) {
        ele.className += ' '+classname;
    }
};

window.removeClass = (ele, classname) => {
    ele.className = ele.className.replace(' '+classname, '');
};

window.hasClass = (ele, classname) => {
    return ele.className.indexOf(classname) > -1;
}

window.getQueryParameterByName = (name) => {
    let url = window.location.href;
    name = name.replace(/[\[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, " "));
}

window.handleApiError = reportApiError

/**
 * We'll load jQuery and the Bootstrap jQuery plugin which provides support
 * for JavaScript based Bootstrap features such as modals and tabs. This
 * code may be modified to fit the specific needs of your application.
 */

window.$ = window.jQuery = require('jquery');

/**
 * Enable bootstraps drop-downs.
 */
import Popper from 'popper.js';
window.Popper = Popper;
require('bootstrap/dist/js/bootstrap');

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

import Echo from 'laravel-echo'

window.Pusher = require('pusher-js');

window.Echo = new Echo({
    broadcaster: 'pusher',
    authEndpoint: `${marque.ui.apiUrl}/broadcasting/auth`,
    key: window.dealerkit.pusher_key,
    cluster: window.dealerkit.pusher_cluster,
    forceTLS: true,
    auth: {
        headers: {
            "X-Api-Token": marque.ui.apiToken,
            "X-Csrf-Token": marque.ui.csrfToken,
            Accept: "application/json",
        },
    },
});